import React, { useEffect, useState } from 'react'
import "./Calculator.scss";
import ComparisonModel from "./ComparisonModel"
import InformationQuota from "./InformationQuota"
import CalQuotationTCO from "./CalQuotationTCO"
import CompareTCO from "./CompareTCO"

import Information3YC from "./Information3YC"
import Cal3YC from "./Cal3YC"

import Swal from "sweetalert2";
import axios from "axios";
import { apiUrl } from '../../constants';
import { Link, useHistory, useLocation } from "react-router-dom";
import { faUserCircle, faSignOutAlt, faKey } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Menu from '../../components/Menu'
import useQuery from '../../components/useQuery'
import useQueryApp from '../../components/useQueryApp'
import useQueryType from '../../components/useQueryType'
import { set } from 'lodash';

const Calculator = () => {
    const history = useHistory();
    const login_token = useQuery();
    const app_version = useQueryApp();
    const device_type = useQueryType();

    const num_validate = new RegExp(/^[0-9.\b]+$/)
    const [token, settoken] = useState(login_token)
    const [app_version_data, setapp_version] = useState(app_version)
    const [device_type_data, setdevice_type] = useState(device_type)
    localStorage.setItem("token", JSON.stringify(login_token))
    localStorage.setItem("app_version", JSON.stringify(app_version))
    localStorage.setItem("device_type", JSON.stringify(device_type))

    const [quota, setquota] = useState(0)
    const [comparison_model, setcomparison_model] = useState("Please select model ...");
    const [datacomparison_model, setDatacomparison_model] = useState("Please select model ...");
    const [pModelID1, setpModelID1] = useState(null);
    const [pModelID2, setpModelID2] = useState(null);
    const [modelGroup, setModelGroup] = useState(null);
    const [displayModal, setDisplayModal] = useState(false);
    const [checkCalculate, setCheckCalculate] = useState(false);

    const [customer_name, setcustomer_name] = useState("");
    const [country, setcountry] = useState("Please select country ...");
    const [country_id, setcountry_id] = useState(null);
    const [displayCountry, setDisplayCountry] = useState(false);

    const [lifetime_working, setlifetime_working] = useState("Please select lifetime ...");
    const [datalifetime_working, setdatalifetime_working] = useState([]);
    const [lifetime_working_id, setlifetime_working_id] = useState(null);
    const [working_mode, setworking_mode] = useState("Please select mode ...");
    const [working_mode_id, setworking_mode_id] = useState(null);
    const [idling_ratio, setidling_ratio] = useState("Please select idling ...");
    const [idling_ratio_id, setidling_ratio_id] = useState(null);
    const [displayModalLifetime, setDisplayModalLifetime] = useState(false);
    const [displayModalWorking, setDisplayModalWorking] = useState(false);
    const [displayModalIdling, setDisplayModalIdling] = useState(false);

    const [startcomparison_model, setstartcomparison_model] = useState()
    const [endcomparison_model, setendcomparison_model] = useState()
    const [startprice, setstartprice] = useState(0.00);
    const [endprice, setendprice] = useState(0.00);
    const [currency, setcurrency] = useState("");
    const [startbucket, setstartbucket] = useState("Select Bucket");
    const [startbucket_id, setstartbucket_id] = useState();
    const [endbucket, setendbucket] = useState("Select Bucket");
    const [endbucket_id, setendbucket_id] = useState();
    const [displayModalstartbucket, setDisplayModalstartbucket] = useState(false);
    const [displayModalendbucket, setDisplayModalendbucket] = useState(false);
    const [datastartbucket, setdatastartbucket] = useState([])
    const [dataendbucket, setdataendbucket] = useState([])

    const [model_yc, setmodel_yc] = useState("");
    const [customer_name_yc, setcustomer_name_yc] = useState("");
    const [country_yc, setcountry_yc] = useState("Please select country ...");
    const [country_yc_id, setcountry_yc_id] = useState("Please select country ...");
    const [currency_yc, setcurrency_yc] = useState("");
    const [displayCountryYc, setDisplayCountryYc] = useState(false);

    const [lifetime_working_3yc, setlifetime_working_3yc] = useState(0.00);
    const [leasing_terms, setleasing_terms] = useState(0.00);
    const [price, setprice] = useState(0.00);
    const [resale_value, setresale_value] = useState(0.00);
    const [interest, setinterest] = useState(0.00);
    const [fuel_consumption, setfuel_consumption] = useState(0.00);
    const [fuel_price, setfuel_price] = useState(0.00);
    const [maintenance_cost, setmaintenance_cost] = useState(0.00);
    const [repair_cost, setrepair_cost] = useState(0.00);
    const [down_payment, setdown_payment] = useState(0.00);

    const [datacountrya, setdatacountry] = useState([])
    const [datacountrya3yc, setdatacountry3yc] = useState([])

    useEffect(() => {
        var get_tco = localStorage.getItem('events_tco')
        var get_tyc = localStorage.getItem('events_tyc')
        var cover_tco = JSON.parse(get_tco)
        var cover_tyc = JSON.parse(get_tyc)

        var get_modeCal = localStorage.getItem('modeCal')
        var cover_modeCal = JSON.parse(get_modeCal)
        console.log(cover_modeCal)
        setquota(cover_modeCal ? cover_modeCal : 0)
        getcountry3yc()
        if (cover_tco) {
            // if (cover_tco.modelGroup) {
            //     if (cover_tco.modelGroup === 1) {
            //         setdatastartbucket([
            //             { id: 1, name: "1.0" },
            //             { id: 2, name: "1.2" },
            //             { id: 3, name: "1.3" },
            //         ])

            //         setdataendbucket([
            //             { id: 1, name: "0.93" },
            //             { id: 2, name: "1.0" },
            //         ])
            //     } else if (cover_tco.modelGroup === 2) {
            //         setdatastartbucket([
            //             { id: 1, name: "0.36" },
            //             { id: 2, name: "0.5" },
            //             { id: 3, name: "0.63" },
            //         ])

            //         setdataendbucket([
            //             { id: 1, name: "0.5" },
            //             { id: 2, name: "0.6" },
            //         ])
            //     } else if (cover_tco.modelGroup === 3) {
            //         setdatastartbucket([
            //             { id: 1, name: "1.0" },
            //             { id: 2, name: "1.2" },
            //             { id: 3, name: "1.3" },
            //         ])

            //         setdataendbucket([
            //             { id: 1, name: "0.93" },
            //             { id: 2, name: "1.0" },
            //         ])
            //     }
            // }
            setModelGroup(cover_tco.modelGroup);
            getcountrytco(cover_tco.modelGroup)
            setcomparison_model(cover_tco.comparison_model);
            setpModelID1(cover_tco.MoDelID1);
            setpModelID2(cover_tco.MoDelID2);
            setcustomer_name(cover_tco.CustomerName);
            setcountry(cover_tco.Country);
            setcountry_id(cover_tco.country_id);

            setlifetime_working(cover_tco.LifeTime);
            setlifetime_working_id(cover_tco.lifetime_working_id);
            setworking_mode(cover_tco.WorkingMode);
            setworking_mode_id(cover_tco.working_mode_id);
            setidling_ratio(cover_tco.LingRatioID);
            setidling_ratio_id(cover_tco.idling_ratio_id);
            
            setstartcomparison_model(cover_tco.startcomparison_model)
            setendcomparison_model(cover_tco.endcomparison_model)
            setstartprice(cover_tco.ModelPrice1);
            setendprice(cover_tco.ModelPrice2);
            setcurrency(cover_tco.currency);
            setstartbucket(cover_tco.ModelBucket1);
            setstartbucket_id(cover_tco.startbucket_id);
            setendbucket(cover_tco.ModelBucket2);
            setendbucket_id(cover_tco.endbucket_id);
            getLifetimeHours(cover_tco.modelGroup)
            let data = [{
                id : cover_tco.MoDelID1
            },{
                id : cover_tco.MoDelID2
            }]
            getBuckets(data)
        }
        if (cover_tyc) {
            setmodel_yc(cover_tyc.ModelName);
            setcustomer_name_yc(cover_tyc.CustomerName);
            setcountry_yc(cover_tyc.Country);
            setcountry_yc_id(cover_tyc.country_yc_id);
            setcurrency_yc(cover_tyc.currency_yc);

            setlifetime_working_3yc(cover_tyc.LifetimeWork);
            setleasing_terms(cover_tyc.LeasingTerm);
            setprice(cover_tyc.PriceVat);
            setresale_value(cover_tyc.ResaleValue);
            setinterest(cover_tyc.InterestRate);
            setfuel_consumption(cover_tyc.FuelConsumption);
            setfuel_price(cover_tyc.FuelPrice);
            setmaintenance_cost(cover_tyc.MaintenCost);
            setrepair_cost(cover_tyc.RepairCost);
            setdown_payment(cover_tyc.DownPayment);
        }
    }, [])

    const getcountrytco = (modelGroup) => {
        var allData_country = []

        axios({
            method: "get",
            url: `${apiUrl}/country-tco?type=TCO&app_version=${app_version}&device_type=${device_type}`,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${login_token}`,
            },
        }).then((res) => {

            res.data.data.map((data, key) => {
                if (data.modelGroup === modelGroup) {
                    allData_country.push({ id: data.id, name: data.country, currency: data.unit })
                }
            })

            localStorage.setItem("datacountry", JSON.stringify(allData_country))
        })
        setdatacountry(allData_country)

    }
    const getBuckets = async (model) => {
        var allDatas = []
        await axios({
            method: "get",
            url: `${apiUrl}/GetModelBuckets?model_id=${model[0].id}`,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${login_token}`,
            },
        }).then((res) => {
            allDatas.push(res.data.data)
            return res.data.data
            // localStorage.setItem("datalifetimeHours", JSON.stringify(res.data.data))
        })
        await axios({
            method: "get",
            url: `${apiUrl}/GetModelBuckets?model_id=${model[1].id}`,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${login_token}`,
            },
        }).then((res) => {
            allDatas.push(res.data.data)
            return res.data.data
            // localStorage.setItem("datalifetimeHours", JSON.stringify(res.data.data))
        })
        setdatastartbucket(allDatas[0])
        setdataendbucket(allDatas[1])
        // await axios({
        //     method: "get",
        //     url: `${apiUrl}/GetModelBuckets?model_id=${modelId}`,
        //     headers: {
        //         Accept: "application/json",
        //         Authorization: `Bearer ${login_token}`,
        //     },
        // }).then((res) => {
        //     allData.push(res.data.data)
        //     localStorage.setItem("datalifetimeHours", JSON.stringify(res.data.data))
        // })
        // setdatalifetime_working(allData[0])

    }
    const getLifetimeHours = async (modelId) => {
        var allData = []

        await axios({
            method: "get",
            url: `${apiUrl}/GetLifetimeHours?model_id=${modelId}`,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${login_token}`,
            },
        }).then((res) => {
            allData.push(res.data.data)
            localStorage.setItem("datalifetimeHours", JSON.stringify(res.data.data))
        })
        console.log(allData)
        setdatalifetime_working(allData[0])

    }

    const getcountry3yc = () => {
        var allData_country = []

        axios({
            method: "get",
            url: `${apiUrl}/country-3yc?type=TCO&app_version=${app_version}&device_type=${device_type}`,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${login_token}`,
            },
        }).then((res) => {

            res.data.data.map((data, key) => {
                allData_country.push({ id: data.id, name: data.country, currency: data.currencyUnit })
            })

            localStorage.setItem("datacountry3yc", JSON.stringify(allData_country))
        })
        setdatacountry3yc(allData_country)

    }

    const handleDisplayModal = (e) => {
        setDisplayModal(e)
    }
    const comparison_model_change = (item) => {
        setcomparison_model(item.name)
        setDatacomparison_model(item)
        setstartcomparison_model(item.group[0].name)
        setendcomparison_model(item.group[1].name)

        setpModelID1(item.group[0].id)
        setpModelID2(item.group[1].id)
        setModelGroup(item.modelGroup)
        setstartbucket("Select Bucket")
        setendbucket("Select Bucket")
        setstartbucket_id(null)
        setendbucket_id(null)
        setcountry("Please select country ...");
        setcountry_id(null);
        getcountrytco(item.modelGroup)
        getLifetimeHours(item.group[0].id)
        console.log(item.group)
        getBuckets(item.group)
        setlifetime_working("Please select lifetime ...");
        setdatalifetime_working([]);
        // if (item.modelGroup === 1) {
        //     setdatastartbucket([
        //         { id: 1, name: "1.0" },
        //         { id: 2, name: "1.2" },
        //         { id: 3, name: "1.3" },
        //     ])

        //     setdataendbucket([
        //         { id: 1, name: "0.93" },
        //         { id: 2, name: "1.0" },
        //     ])
        // } else if (item.modelGroup === 2) {

        //     setdatastartbucket([
        //         { id: 1, name: "0.36" },
        //         { id: 2, name: "0.5" },
        //         { id: 3, name: "0.63" },
        //     ])

        //     setdataendbucket([
        //         { id: 1, name: "0.5" },
        //         { id: 2, name: "0.6" },
        //     ])
        // }  else if (item.modelGroup === 3) {

        //     setdatastartbucket([
        //         { id: 1, name: "1.0" },
        //         { id: 2, name: "1.2" },
        //         { id: 3, name: "1.3" },
        //     ])

        //     setdataendbucket([
        //         { id: 1, name: "0.93" },
        //         { id: 2, name: "1.0" },
        //     ])
        // } 

    }


    const handleDisplayCountry = (e) => {
        setDisplayCountry(e)
    }
    const customer_name_change = (item) => {
        setcustomer_name(item)
    }
    const country_change = (item) => {
        setcountry(item.name)
        setcountry_id(item.id)
        setcurrency(item.currency)
    }

    const lifetime_working_change = (item) => {
        setlifetime_working(item.master_value)
        setlifetime_working_id(item.id)
    }
    const handleDisplayModalLifetime = (e) => {
        setDisplayModalLifetime(e)
    }

    const working_mode_change = (item) => {
        setworking_mode(item.name)
        setworking_mode_id(item.id)
    }
    const handleDisplayModalWorking = (e) => {
        setDisplayModalWorking(e)
    }

    const handleDisplayModalIdling = (e) => {
        setDisplayModalIdling(e)
    }
    const idling_ratio_change = (item) => {
        setidling_ratio(item.name)
        setidling_ratio_id(item.id)
    }

    const handleDisplayModalstartbucket = (e) => {
        setDisplayModalstartbucket(e)
    }
    const start_bucket_change = (item) => {
        setstartbucket(item.bucket)
        setstartbucket_id(item.id)
    }

    const handleDisplayModalendbucket = (e) => {
        setDisplayModalendbucket(e)
    }
    const end_bucket_change = (item) => {
        setendbucket(item.bucket)
        setendbucket_id(item.id)
    }


    const AlertError = (message) => {
        Swal.fire("Calculate!", message, "error");
    };
    const setDegitSalary = (number) => {
        if (number) {
            var numbers = removeDegitSaraly(number);
            var parts = Number(numbers).toFixed(2).toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            let numbera = parts.join(".");
            return numbera;
        } else if (Number(number) === 0) {
            return 0;
        } else {
            return " ";
        }
    };

    const removeDegitSaraly = (number) => {
        if (number) {
            var parts = number.toString().split(".");
            parts[0] = parts[0].replace(",", "");
            let numbera = parts.join(".");
            return numbera;
        } else {
            return " ";
        }
    };

    const removeMode = (str) => {
        if (str) {
            let parts = str.split(" ");
            return parts[0];
        } else {
            return " ";
        }
    };

    const submit = () => {
        setCheckCalculate(true)
        var token_get = localStorage.getItem('token')
        var cover_token_get = JSON.parse(token_get)
        if (quota === 0) {

            if (pModelID1 === undefined || pModelID1 === null || pModelID1 === "") {
                return AlertError("Please select model !!");
            }
            if (customer_name === undefined || customer_name === null || customer_name === "") {
                return AlertError("Please input Quotation reference !!");
            }
            if (country_id === undefined || country_id === null || country_id === "") {
                return AlertError("Please select country !!");
            }
            if (lifetime_working_id === undefined || lifetime_working_id === null || lifetime_working_id === "") {
                return AlertError("Please select life time working !!");
            }
            if (working_mode_id === undefined || working_mode_id === null || working_mode_id === "") {
                return AlertError("Please select working mode !!");
            }
            if (idling_ratio_id === undefined || idling_ratio_id === null || idling_ratio_id === "") {
                return AlertError("Please select idling ratio !!");
            }
            if (startprice === 0.00 || startprice === undefined || startprice === null || startprice === "") {
                return AlertError("Please input price !!");
            }
            if (endprice === 0.00 || endprice === undefined || endprice === null || endprice === "") {
                return AlertError("Please input price !!");
            }
            if (startbucket_id === undefined || startbucket_id === null || startbucket_id === "") {
                return AlertError("Please select bucket !!");
            }
            if (endbucket_id === undefined || endbucket_id === null || endbucket_id === "") {
                return AlertError("Please select bucket !!");
            }
            var events = {
                MoDelID1: pModelID1,
                MoDelID2: pModelID2,
                comparison_model: comparison_model,
                modelGroup: modelGroup,
                CustomerName: customer_name,
                Country: country,
                country_id: country_id,
                LifeTime: lifetime_working,
                lifetime_working_id: lifetime_working_id,
                WorkingMode: working_mode,
                working_mode_id: working_mode_id,
                LingRatioID: idling_ratio,
                idling_ratio_id: idling_ratio_id,
                startcomparison_model: startcomparison_model,
                endcomparison_model: endcomparison_model,
                ModelPrice1: startprice,
                ModelPrice2: endprice,
                currency: currency,
                ModelBucket1: startbucket,
                startbucket_id: startbucket_id,
                ModelBucket2: endbucket,
                endbucket_id: endbucket_id
            };
            localStorage.setItem("events_tco", JSON.stringify(events))
            localStorage.setItem("modeCal", JSON.stringify(0))

            var send = {
                MoDelID1: pModelID1,
                MoDelID2: pModelID2,
                CustomerName: customer_name,
                Country: country,
                LifeTime: removeDegitSaraly(lifetime_working),
                WorkingMode: Number(working_mode_id) === 1 ? removeMode(working_mode) : removeMode("E0 mode"),
                LingRatioID: idling_ratio_id === 3 ? 30 : idling_ratio,
                ModelPrice1: removeDegitSaraly(startprice),
                ModelPrice2: removeDegitSaraly(endprice),
                ModelBucket1: startbucket,
                ModelBucket2: endbucket
            };
            axios.post(`${apiUrl}/calculate-tco?app_version=${app_version_data}&device_type=${device_type_data}`, send, {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${cover_token_get}`,
                }
            })
                .then(async (res) => {
                    //check askForSurvey 
                    //if true show modal do you have time
                    //if click OK => go to link https://forms.gle/1HFJ2qF9thU5BDN29
                    //else cancal close 
                    //update askForSurvey => false

                    console.log(res.data)


                    if (res.data.data.askForSurvey === null) {
                        Swal.fire({
                            title: "Do you have time to make survey for improve app better ?",
                            text: "",
                            showCancelButton: true,
                            confirmButtonText: "OK",
                            cancelButtonText: "Cancel",
                        }).then((result) => {

                            if (result.value) {
                                console.log(true)
                                //update api askForSurvey => 1
                                //if click OK => go to link https://forms.gle/1HFJ2qF9thU5BDN29
                                updatesurvey(1)
                                setCheckCalculate(false)
                                window.location.href = `?survey_link=https://forms.gle/1HFJ2qF9thU5BDN29`

                            } else if (result.dismiss === Swal.DismissReason.cancel) {
                                console.log(false)

                                updatesurvey(0)
                                setCheckCalculate(false)
                                //update api askForSurvey => 0
                                history.push(`/ResultTCO?login_token=${cover_token_get}`, { data: res.data.data, events, comparison_model, currency });

                            }
                        });
                    } else {
                        setCheckCalculate(false)
                        history.push(`/ResultTCO?login_token=${cover_token_get}`, { data: res.data.data, events, comparison_model, currency });
                    }


                })
                .catch((err) => {
                    if (err.response.status === 401) {
                        setCheckCalculate(false)
                        window.location.href = `callback?is_un_auth=${true}&msg=${err.response.data.message}`
                    } else {
                        setCheckCalculate(false)
                        Swal.fire("Error", `${err.response.data.message}`, "error");
                    }
                });
        }
        if (quota === 1) {
            if (model_yc === undefined || model_yc === null || model_yc === "") {
                return AlertError("Please input model !!");
            }
            if (customer_name_yc === undefined || customer_name_yc === null || customer_name_yc === "") {
                return AlertError("Please input 3YC reference number !!");
            }
            if (country_yc_id === undefined || country_yc_id === null || country_yc_id === "") {
                return AlertError("Please select country !!");
            }
            if (price === 0.00 || price === undefined || price === null || price === "") {
                return AlertError("Please input price !!");
            }
            if (resale_value === 0.00 || resale_value === undefined || resale_value === null || resale_value === "") {
                return AlertError("Please input resale value !!");
            }
            if (leasing_terms === 0.00 || leasing_terms === undefined || leasing_terms === null || leasing_terms === "") {
                return AlertError("Please input leasing terms !!");
            }
            if (interest === undefined || interest === null || interest === "") {
            // if (interest === 0.00 || interest === undefined || interest === null || interest === "") {
                return AlertError("Please input interest !!");
            }
            if (down_payment === 0.00 || down_payment === undefined || down_payment === null || down_payment === "") {
                return AlertError("Please input down payment !!");
            }
            if (lifetime_working_3yc === 0.00 || lifetime_working_3yc === undefined || lifetime_working_3yc === null || lifetime_working_3yc === "") {
                return AlertError("Please input life time working !!");
            }
            if (fuel_consumption === undefined || fuel_consumption === null || fuel_consumption === "") {
                return AlertError("Please input fuel consumption !!");
            }
            if (fuel_price === 0.00 || fuel_price === undefined || fuel_price === null || fuel_price === "") {
                return AlertError("Please input fuel price !!");
            }
            if (maintenance_cost === undefined || maintenance_cost === null || maintenance_cost === "") {
                return AlertError("Please input maintenance cost !!");
            }
            if (repair_cost === undefined || repair_cost === null || repair_cost === "") {
                return AlertError("Please input repair cost !!");
            }
            var events = {
                CustomerName: customer_name_yc,
                Country: country_yc,
                country_yc_id: country_yc_id,
                currency_yc: currency_yc,
                ModelName: model_yc,
                PriceVat: price,
                ResaleValue: resale_value,
                LeasingTerm: leasing_terms,
                InterestRate: interest,
                DownPayment: down_payment,
                LifetimeWork: lifetime_working_3yc,
                FuelConsumption: fuel_consumption,
                FuelPrice: fuel_price,
                MaintenCost: maintenance_cost,
                RepairCost: repair_cost,
            };

            localStorage.setItem("events_tyc", JSON.stringify(events))
            localStorage.setItem("modeCal", JSON.stringify(1))


            var send = {
                CustomerName: customer_name_yc,
                Country: country_yc,
                ModelName: model_yc,
                PriceVat: price,
                ResaleValue: resale_value,
                LeasingTerm: leasing_terms,
                InterestRate: interest,
                DownPayment: down_payment,
                LifetimeWork: lifetime_working_3yc,
                FuelConsumption: fuel_consumption,
                FuelPrice: fuel_price,
                MaintenCost: maintenance_cost,
                RepairCost: repair_cost,
            };
            axios.post(`${apiUrl}/calculate-3yc?app_version=${app_version_data}&device_type=${device_type_data}`, send, {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${cover_token_get}`,
                }
            })
                .then(async (res) => {
                    console.log(res.data.data.askForSurvey)
                    if (res.data.data.askForSurvey === null) {
                        Swal.fire({
                            title: "Do you have time to make survey for improve app better ?",
                            text: "",
                            showCancelButton: true,
                            confirmButtonText: "OK",
                            cancelButtonText: "Cancel",
                        }).then((result) => {
                            if (result.value) {
                                console.log(true)
                                //update api askForSurvey => 1
                                //if click OK => go to link https://forms.gle/1HFJ2qF9thU5BDN29
                                updatesurvey(1)
                                setCheckCalculate(false)
                                window.location.href = `?survey_link=https://forms.gle/1HFJ2qF9thU5BDN29`

                            } else if (result.dismiss === Swal.DismissReason.cancel) {
                                console.log(false)

                                updatesurvey(0)
                                setCheckCalculate(false)
                                //update api askForSurvey => 0
                                history.push(`/Result3YC?login_token=${cover_token_get}`, { data: res.data.data, events, comparison_model: model_yc, currency: currency_yc });
                            }

                        });
                    } else {
                        setCheckCalculate(false)
                        history.push(`/Result3YC?login_token=${cover_token_get}`, { data: res.data.data, events, comparison_model: model_yc, currency: currency_yc });
                    }

                })
                .catch((err) => {
                    if (err.response.status === 401) {
                        setCheckCalculate(false)
                        window.location.href = `callback?is_un_auth=${true}&msg=${err.response.data.message}`
                    } else {
                        setCheckCalculate(false)
                        Swal.fire("Error", `${err.response.data.message}`, "error");
                    }
                });


        }
    }
    const updatesurvey = (type) => {
        axios({
            method: "put",
            url: `${apiUrl}/updatesurvey?is_survey=${type === 1 ? true : false}`,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${login_token}`,
            },
        }).then((res) => {
        }).catch((error) => {
            Swal.fire("Error", `${error.response.data.message}`, "error");

        })
    }

    const clear = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You will clear all !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, clear all!",
            cancelButtonText: "No, keep it",
        }).then((result) => {
            if (result.value) {
                if (quota === 0) {
                    localStorage.removeItem('events_tco');
                    setcomparison_model("Please select model ...");
                    setpModelID1(null);
                    setpModelID2(null);
                    setDisplayModal(false);
                    setModelGroup(null);
                    setcustomer_name("");
                    setcountry("Please select country ...");
                    setcountry_id(null);
                    setDisplayCountry(false);

                    setlifetime_working("Please select lifetime ...");
                    setlifetime_working_id(null);
                    setworking_mode("Please select mode ...");
                    setworking_mode_id(null);
                    setidling_ratio("Please select idling ...");
                    setidling_ratio_id(null);
                    setDisplayModalLifetime(false);
                    setDisplayModalWorking(false);
                    setDisplayModalIdling(false);

                    setstartcomparison_model()
                    setendcomparison_model()
                    setstartprice();
                    setendprice();
                    setcurrency("");
                    setstartbucket("Select Bucket");
                    setstartbucket_id();
                    setendbucket("Select Bucket");
                    setendbucket_id();
                    setDisplayModalstartbucket(false);
                    setDisplayModalendbucket(false);
                }

                if (quota === 1) {
                    localStorage.removeItem('events_tyc');

                    setmodel_yc("");
                    setcustomer_name_yc("");
                    setcountry_yc("Please select country ...");
                    setcountry_yc_id("Please select country ...");
                    setcurrency_yc("");
                    setDisplayCountryYc(false);

                    setlifetime_working_3yc("");
                    setleasing_terms("");
                    setprice("");
                    setresale_value("");
                    setinterest("");
                    setfuel_consumption("");
                    setfuel_price("");
                    setmaintenance_cost("");
                    setrepair_cost("");
                    setdown_payment("");

                }
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Cancelled", "Your not clear all", "error");
            }
        });

    }

    const model_yc_change = (item) => {
        setmodel_yc(item)
    }

    const customer_name_change_yc = (item) => {
        setcustomer_name_yc(item)
    }

    const country_change_yc = (item) => {
        setcountry_yc(item.name)
        setcountry_yc_id(item.id)
        setcurrency_yc(item.currency)
    }

    const handleDisplayCountryYc = (e) => {
        setDisplayCountryYc(e)
    }
    return (
        <div>

            <div className="sticky-headder">
                <div className="headder-cal-group shadow">

                    <div className="row">
                        <div className="col">
                            <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() =>
                                window.location.href = `/callback?is_back=true`
                            }>
                                <path d="M7.35031 0.7256C7.64636 0.4248 8.11244 0.4248 8.40848 0.7256C8.69453 1.01624 8.69453 1.49995 8.40848 1.78991L3.04292 7.24157H19.7485C20.1613 7.24157 20.5 7.57488 20.5 7.99424C20.5 8.4136 20.1613 8.75776 19.7485 8.75776H3.04292L8.40848 14.1992C8.69453 14.5 8.69453 14.9844 8.40848 15.2744C8.11244 15.5752 7.64636 15.5752 7.35031 15.2744L0.714536 8.53216C0.428488 8.24152 0.428488 7.7578 0.714536 7.46784L7.35031 0.7256Z" fill="black" />
                            </svg>

                        </div>
                        <div className="col text-center">
                            <a>
                                <p style={{
                                    textAlign: "center",
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "16px",
                                    lineHeight: "19px",
                                }}>
                                    
                                    Calculator
                                </p>
                            </a>
                            

                            {/* history.push(`/callback?is_back=true&login_token=${token}&app_version=${app_version_data}&device_type=${device_type_data}`) */}
                            {/* <a style={{ color: "#000", fontSize: "30px" }}>Calculator</a> */}
                            
                        </div>
                        <div className="col text-right">
                            <a style={{ color: "#3b4fbc", fontSize: "16px", marginRight: "10px", paddingTop: "5px" }} onClick={() =>
                                    history.push(`/History?login_token=${token}`)
                                }>

                                <p style={{
                                    textAlign: "center",
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "16px",
                                    lineHeight: "19px",
                                }}>
                                    History
                                </p>
                                    
                                </a>
                                <Menu />
                        </div>
                    </div>
                    {/* <div className="d-flex justify-content-between">
                        <a style={{ color: "#000", fontSize: "30px" }}>Calculator</a>
                        <div className="row" style={{ paddingTop: "10px", marginRight: "2px" }}>
                            <a style={{ color: "#3b4fbc", fontSize: "16px", marginRight: "10px", paddingTop: "5px" }} onClick={() =>
                                history.push(`/History?login_token=${token}`)
                            }>
                                History
                            </a>
                            <Menu />
                        </div>
                    </div> */}

                    <div style={{ /*marginTop: "24px",*/ paddingBottom: "16px", backgroundColor: "#fff" }}>
                        <ul
                            id="pills-tab"
                            role="tablist"
                            className="nav nav-pills d-flex row"
                            aria-orientation="vertical"
                        >
                            <li className={quota === 0 ? "active col-6" : "col-6"} onClick={() => {
                                setquota(0)
                                localStorage.setItem("modeCal", JSON.stringify(0))
                            }}>
                                <a
                                    className={
                                        quota === 0 ? "nav-link active" : "nav-link"
                                    }
                                    id="pills-history-tab"
                                    data-toggle="pill"
                                    href="#pills-history"
                                    role="tab"
                                    aria-controls="pills-history"
                                    aria-selected="true"
                                    aria-expanded="true"
                                    style={{
                                        fontSize: "14px",
                                        color: "#000",
                                        background: "#F6F7FB",
                                        borderRadius: "16px",
                                        textAlign: "center"

                                    }}
                                >
                                    Quotation TCO
                                </a>
                            </li>
                            <li className={quota === 1 ? "active col-6" : "col-6"} onClick={() => {
                                setquota(1)
                                localStorage.setItem("modeCal", JSON.stringify(1))
                            }}>
                                <a
                                    className={
                                        quota === 1 ? "nav-link active" : "nav-link"
                                    }
                                    id="pills-redemption-tab"
                                    data-toggle="pill"
                                    href="#pills-redemption"
                                    role="tab"
                                    aria-controls="pills-redemption"
                                    aria-selected="false"
                                    aria-expanded="true"

                                    style={{
                                        fontSize: "14px",
                                        color: "#000",
                                        background: "#F6F7FB",
                                        borderRadius: "16px",
                                        textAlign: "center"
                                    }}
                                >
                                    3YC Calculator
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginTop: "180px" }}>
            </div>

            <div className="container">
                <div className="tab-content" id="pills-tabContent">
                    <div
                        className={
                            quota === 0
                                ? "tab-pane fade show active row"
                                : "tab-pane fade row"
                        }
                        id="pills-history"
                        role="tabpanel"
                        aria-labelledby="pills-history-tab"
                    >

                        {/* <Name hanle={test} /> */}
                        <ComparisonModel
                            comparison_model={comparison_model}
                            comparison_model_change={comparison_model_change}
                            displayModal={displayModal}
                            handleDisplayModal={handleDisplayModal} />

                        <div style={{ marginBottom: "20px", marginTop: "20px", backgroundColor: "#F6F7FB" }}>
                            <div className="container" style={{ paddingBottom: "20px", paddingTop: "20px" }}>
                                <span>Information</span>
                            </div>
                        </div>

                        <InformationQuota
                            customer_name={customer_name}
                            customer_name_change={customer_name_change}
                            country={country}
                            country_change={country_change}
                            displayModal={displayCountry}
                            datacountrya={datacountrya}
                            handleDisplayModal={handleDisplayCountry}
                        />

                        <div style={{ marginBottom: "20px", marginTop: "20px", backgroundColor: "#F6F7FB" }}>
                            <div className="container" style={{ paddingBottom: "20px", paddingTop: "20px" }}>
                                <span>Calculator</span>
                            </div>
                        </div>
                        {/* comparison_model */}
                        <CalQuotationTCO
                            datacomparison_model={datacomparison_model}
                            comparison_model={comparison_model}
                            lifetime_working={lifetime_working}
                            datalifetime_working={datalifetime_working}
                            lifetime_working_change={lifetime_working_change}
                            working_mode={working_mode}
                            working_mode_change={working_mode_change}
                            idling_ratio={idling_ratio}
                            idling_ratio_change={idling_ratio_change}
                            displayModalLifetime={displayModalLifetime}
                            handleDisplayModalLifetime={handleDisplayModalLifetime}
                            displayModalWorking={displayModalWorking}
                            handleDisplayModalWorking={handleDisplayModalWorking}
                            displayModalIdling={displayModalIdling}
                            handleDisplayModalIdling={handleDisplayModalIdling}
                        />

                        <div style={{ marginTop: "20px", backgroundColor: "#F6F7FB" }}>
                            <div className="container" style={{ paddingBottom: "20px", paddingTop: "20px" }}>
                                <span>Compare</span>
                            </div>
                        </div>

                        <CompareTCO
                            comparison_model={comparison_model}
                            startcomparison_model={startcomparison_model}
                            endcomparison_model={endcomparison_model}
                            datastartbucket={datastartbucket}
                            dataendbucket={dataendbucket}
                            startprice={startprice}
                            setstartprice={setstartprice}
                            endprice={endprice}
                            setendprice={setendprice}
                            currency={currency}
                            startbucket={startbucket}
                            displayModalstartbucket={displayModalstartbucket}
                            handleDisplayModalstartbucket={handleDisplayModalstartbucket}
                            start_bucket_change={start_bucket_change}

                            endbucket={endbucket}
                            displayModalendbucket={displayModalendbucket}
                            handleDisplayModalendbucket={handleDisplayModalendbucket}
                            end_bucket_change={end_bucket_change}
                        />

                    </div>
                    <div
                        className={
                            quota === 1
                                ? "tab-pane fade show active row"
                                : "tab-pane fade row"
                        }
                        id="pills-redemption"
                        role="tabpanel"
                        aria-labelledby="pills-redemption-tab"
                    >
                        <div style={{ marginBottom: "20px", marginTop: "20px", backgroundColor: "#F6F7FB" }}>
                            <div className="container" style={{ paddingBottom: "20px", paddingTop: "20px" }}>
                                <span>Information</span>
                            </div>
                        </div>
                        <Information3YC
                            customer_name_yc={customer_name_yc}
                            customer_name_change_yc={customer_name_change_yc}

                            country_yc={country_yc}
                            datacountrya3yc={datacountrya3yc}
                            country_change_yc={country_change_yc}
                            displayCountryYc={displayCountryYc}
                            handleDisplayCountryYc={handleDisplayCountryYc}

                            model_yc={model_yc}
                            model_yc_change={model_yc_change}
                        />
                        <div style={{ marginBottom: "20px", marginTop: "20px", backgroundColor: "#F6F7FB" }}>
                            <div className="container" style={{ paddingBottom: "20px", paddingTop: "20px" }}>
                                <span>Calculator</span>
                            </div>
                        </div>
                        <Cal3YC
                            currency_yc={currency_yc}

                            setDegitSalary={setDegitSalary}
                            removeDegitSaraly={removeDegitSaraly}

                            lifetime_working_3yc={lifetime_working_3yc}
                            lifetime_working_3yc_change={setlifetime_working_3yc}

                            leasing_terms={leasing_terms}
                            leasing_terms_change={setleasing_terms}

                            price={price}
                            price_change={setprice}

                            resale_value={resale_value}
                            resale_value_change={setresale_value}

                            interest={interest}
                            interest_change={setinterest}

                            fuel_consumption={fuel_consumption}
                            fuel_consumption_change={setfuel_consumption}

                            fuel_price={fuel_price}
                            fuel_price_change={setfuel_price}

                            maintenance_cost={maintenance_cost}
                            maintenance_cost_change={setmaintenance_cost}

                            repair_cost={repair_cost}
                            repair_cost_change={setrepair_cost}

                            down_payment={down_payment}
                            down_payment_change={setdown_payment}

                        />
                    </div>
                </div>
            </div>


            <div className="container" style={{ marginTop: "130px" }}>
            </div>

            <div className="sticky-buttom">
                <div className="container">

                    <div className="row">
                        <div className="col-4">
                            <p style={{
                                color: "#898989",
                                paddingTop: "15px"
                            }}
                                onClick={() => clear()}
                            >Clear all</p>
                        </div>
                        <div className="col-8">

                            <button
                                className="btn btn-primary fullwidth"
                                style={{
                                    background: "#140A9A",
                                    borderRadius: "5px",
                                    height: "50px",
                                    color: "#fff",
                                    paddingTop: "15px"
                                }}
                                onClick={() => {

                                    submit()

                                }}
                            >
                                Calculate
                            </button>

                        </div>
                    </div>
                </div>
            </div>


        </div >

    )
}

export default Calculator
